module.exports = __webpack_public_path__ + "static/img/drilling01.34f22027.png";